import React, { useState, useEffect } from "react";

const AddMemberPanel = ({
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  emailError,
  setEmailError,
  phoneError,
  setPhoneError,
  validatePhoneNumber,
  handleRegisterCustomer,
  loading,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.startsWith("254")) {
      value = value.slice(0, 12);
    } else if (value.startsWith("0")) {
      value = value.slice(0, 10);
    }

    setPhoneNumber(value);

    if (value.length > 0) {
      validatePhoneNumber(value);
    } else {
      setPhoneError("");
    }
  };

  useEffect(() => {
    const isPhoneValid = validatePhoneNumber(phoneNumber);
    const isEmailValid =
      email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && !emailError;

    setIsButtonDisabled(!(isPhoneValid && isEmailValid));
  }, [phoneNumber, email, emailError]);
  return (
    <div className="h-full flex flex-col justify-between p-6">
      <div>
        <div className="mt-5 text-[20px] font-[600]">
          <p className="font-bold">New Member - Enter Email and Phone Number</p>
          <p className="text-[15px]  font-[300]">
            Enter email and phone number of the new member to get started
          </p>
        </div>

        <div className="mt-32">
          <label className="font-medium">Email</label>
          <input
            type="email"
            className="w-full border p-2 mt-2 text-[#000000] bg-[#EAEAEA] border-[1px] border-[#EAEAEA]"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
          />
          {emailError && <p className="text-red-500 text-sm">{emailError}</p>}
        </div>
        <div className="flex flex-col justify-center mt-10">
          <label
            htmlFor="phoneNumberInput"
            className="mb-1 text-md font-medium text-[#000000]"
          >
            Phone number
          </label>
          <div className="flex gap-5">
            <input
              type="text"
              id="phoneNumberInput"
              name="mobileno"
              placeholder="Enter your phone number"
              value={phoneNumber}
              onChange={handlePhoneChange}
              className={`w-full py-2 px-4 border bg-[#EAEAEA] border-[#EAEAEA] border-[1px] ${
                phoneError ? "border-red-500" : "border-[#000]"
              }`}
            />
          </div>
          {phoneError && (
            <p className="text-red-500 text-sm mt-1">{phoneError}</p>
          )}
        </div>
      </div>

      <button
        onClick={handleRegisterCustomer}
        disabled={isButtonDisabled}
        className={`py-2 rounded text-white ${
          isButtonDisabled ? "bg-[#DDDDDD] cursor-not-allowed" : "bg-[#005C53]"
        }`}
      >
        {loading ? "Registering..." : "Continue"}
      </button>
    </div>
  );
};

export default AddMemberPanel;
